export default function DireccionParadaDeAutobusMap() {
  return;
}